import React from 'react';

import Breadcumb from './Breadcumb';
import Content from './Content';
import CallToAction from './CallToaction';
import Benefits from './Benefits';

function Main() {
  return (
    <>
      <Breadcumb />
      <Content />
      <Benefits />
      <CallToAction />
    </>
  );
}

export default Main;
